import { render, staticRenderFns } from "./authorization-gate-settings.vue?vue&type=template&id=043d687d"
import script from "./authorization-gate-settings.vue?vue&type=script&lang=js"
export * from "./authorization-gate-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports